<template>
  <div id="landing">
    <LandingBanner :rgStats="rgStats" :isMounted="isMounted" />
    <HowItWorks :rgStats="rgStats" :isMounted="isMounted" />
    <PaymentsInfo :rgStats="rgStats" :isMounted="isMounted" />
    <Testimonials />
    <!-- <Alliances /> -->
    <NewFundDestinations />
    <Statistics :rgStats="rgStats" :isMounted="isMounted" :odsStats="odsStats"/>
    <Portfolio  :rgStats="rgStats" :isMounted="isMounted" />
    <InvestmentOpportunities />
    <WhyBanner />
  </div>
</template>

<script>
import sal from 'sal.js'
import LandingBanner from '@components/landing-components/LandingBanner.vue';
import HowItWorks from '@components/landing-components/HowItWorks.vue';
import PaymentsInfo from '@components/landing-components/PaymentsInfo.vue';
import Testimonials from '@components/landing-components/Testimonials.vue';
import Alliances from '@components/landing-components/Alliances.vue';
import Statistics from '@components/landing-components/Statistics.vue';
import Portfolio from '@components/landing-components/Portfolio.vue';
import InvestmentOpportunities from '@components/landing-components/InvestmentOpportunities.vue';
import WhyBanner from '@components/landing-components/WhyBanner.vue';
import NewFundDestinations from '../components/landing-components/NewFundDestinations.vue';
export default {
  name: "HomePage",
  components: {
    LandingBanner,
    HowItWorks,
    PaymentsInfo,
    Testimonials,
    Alliances,
    Statistics,
    Portfolio,
    InvestmentOpportunities,
    WhyBanner,
    NewFundDestinations
  },
  data() {
    return {
      rgStats: null,
      odsStats: null,
      isMounted: false
    }
  },
  async mounted() {
    await sal();
    await this.RgStats();
  },
  methods: {
    async RgStats() {
      this.isMounted = false;
      this.rgStats = await this.setRgStatsData();
      this.odsStats = await this.setRgStatsData(true);
      this.isMounted = true;
    }
  }
}
</script>

<style scoped></style>